// extracted by mini-css-extract-plugin
export default {"HiddenButton":"personalDetailsForm_HiddenButton_SRdSs"};